<template>
  <div class="tracking">
    <div class="desktopTitleWrapper">
      <div class="desktopTitle">پیگیری شکایت</div>
    </div>
    <div class="trackingTitleWrapper">
      <div class="trackingTitle">پیگیری شکایت</div>
    </div>
    <div class="trackingContainer">
      <div class="containerSearch">
        <div class="searchWrapper">
          <input
            type="search"
            class="searchBar"
            placeholder="کدپیگیری خود را وارد کنید"
            v-model="trackingCode"
            maxlength="5"
          />
          <div class="searchBtn" @click="searchByTrackingCode">
            <div class="desktopLabel">بررسی وضعیت</div>
            <div class="mobileLabel">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!form.loadeMoreLoading && filteredList.length > 0"
        class="complaintsList"
      >
        <div
          class="complaintThumb"
          v-for="(v, i) in filteredList"
          :key="i"
          :class="{ show: showComplaint == i }"
          @click="showComplaintHandler(v, i)"
        >
          <div class="thumbHeader">
            <div class="headerInfo">
              <div class="headerTitle">
                <span> شکایت {{ v.tracking_number }}</span>
                <div
                  class="headerStatusThumb"
                  :class="[v.status == 'pending' ? 'pending' : 'approved']"
                >
                  {{ v.status_fa }}
                </div>
              </div>
              <div class="headerDate">{{ v.date }}</div>
            </div>
            <div class="headerarrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                />
              </svg>
            </div>
          </div>
          <div class="thumbMain">
            <div class="mainContainer">
              <div class="mainRow gridRow">
                <div class="rowColumn">
                  <div class="columnTitle">طرف شکایت</div>
                  <div class="columnValue">{{ v.target }}</div>
                </div>
                <div class="rowColumn">
                  <div class="columnTitle">نام شخص</div>
                  <div class="columnValue">{{ v.nickname }}</div>
                </div>
              </div>
              <div class="mainRow gridRow">
                <div class="rowColumn">
                  <div class="columnTitle">نام شاکی</div>
                  <div class="columnValue">{{ v.beefer }}</div>
                </div>
                <div class="rowColumn">
                  <div class="columnTitle">شماره شاکی</div>
                  <div class="columnValue">{{ v.phone }}</div>
                </div>
              </div>
              <div class="mainRow">
                <div class="rowColumn">
                  <div class="columnTitle">موضوع شکایت</div>
                  <div class="columnValue">{{ v.subject }}</div>
                </div>
              </div>
              <div v-if="v.des" class="mainRow">
                <div class="rowColumn">
                  <div class="columnTitle">توضیحات</div>
                  <div class="columnValue" v-html="v.des"></div>
                </div>
              </div>
              <div v-if="v.replay" class="responseThumb">
                <div class="thumbHeader">پاسخ از طرف مدیریت</div>
                <div class="thumbMain" v-html="v.replay"></div>
                <!-- <div class="thumbFooter">پاسخ داده شده در 14 تیر 1405</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="!form.loadeMoreLoading && filteredList.length == 0"
        class="complaintsList"
      >
        <div class="noResult">موردی برای نمایش وجود ندارد!</div>
      </div>
      <div v-else class="complaintsList">
        <div class="loadeMoreWrapper">
          <div class="loadMore"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "complaintTracking",
  data() {
    return {
      showComplaint: -1,
      complaintList: [],
      filteredList: [],
      trackingCode: "",
      form: {
        uid: this.$store.state.auth.uid,
        page: 1,
        per_page: 8,
        loadeMore: true,
        loadeMoreLoading: false,
      },
    };
  },
  watch: {
    complaintList(newList) {
      this.filteredList = newList;
    },
  },
  methods: {
    searchByTrackingCode() {
      const code = this.trackingCode.trim().toLowerCase();
      if (!code) {
        this.filteredList = this.complaintList;
        return;
      }
      this.filteredList = this.complaintList.filter((item) =>
        item.tracking_number.toLowerCase().includes(code)
      );
    },
    showComplaintHandler(complaint, index) {
      if (this.showComplaint != index) {
        this.showComplaint = index;
        this.helperPost("complaint-check", {
          complaint_id: complaint.id,
        }).then((response) => {
          if (response.data.result == 1) {
            console.log("done");
          }
        });
      } else {
        this.showComplaint = -1;
      }
    },
    getComplaintList(param) {
      let self = this;
      this.form.loadeMore = true;
      this.form.loadeMoreLoading = true;
      this.form.page++;
      if (param == "first") {
        this.form.page = 1;
        this.complaintList = [];
      }
      this.helperPost("complaint-list", this.form).then((r) => {
        if (r.data.result == 0) {
          self.complaintList = [];
          if (param != "first") {
            self.form.page -= 1;
          }
        } else {
          self.complaintList = self.complaintList.concat(r.data.data.list);
          if (r.data.data.total_page == self.form.page) {
            self.form.loadeMore = false;
          }
        }
        this.form.loadeMoreLoading = false;
      });
    },
    handleWindowScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      let spaceBottom = window.innerWidth > 1000 ? 686.6 : 100;
      if (scrollTop + windowHeight + spaceBottom >= fullHeight) {
        if (this.form.loadeMore && !this.form.loadeMoreLoading) {
          this.getComplaintList();
        }
      }
    },
  },
  mounted() {
    this.getComplaintList("first");
  },
};
</script>

<style lang="scss" scoped>
.tracking {
  padding-top: 16px;
  padding-bottom: 32px;
  .desktopTitleWrapper {
    .desktopTitle {
      margin: auto;
      width: 90%;
      font-size: 25px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 1.5em;
      padding-bottom: 15px;
      position: relative;
      font-family: "iranyekanB";
      margin-top: 100px;
      margin-bottom: 38px;
      text-align: center;

      &::after {
        margin: auto;
        content: "";
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 5px;
        width: 100px;
        background: #000000;
        border-radius: 5px;
      }

      &::before {
        margin: auto;
        content: "";
        position: absolute;
        right: 0;
        left: 0;
        bottom: 2px;
        height: 1px;
        width: 95%;
        max-width: 255px;
        background: #333;
      }
    }
  }

  .trackingTitleWrapper {
    display: none;
    width: 100%;
    text-align: center;
    margin-top: 18px;

    .trackingTitle {
      position: relative;
      font-family: "iranyekanB", sans-serif;
      font-size: 1.125rem;
      margin: 16px auto 12px;
      text-align: center;

      &::after,
      &::before {
        content: "";
        display: block;
        width: 76px;
        height: 1px;
        background: rgb(213, 213, 213);
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      &::after {
        left: 0;
      }

      &:before {
        right: 0;
      }
    }
  }

  .trackingContainer {
    max-width: 896px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 24px;

    .containerSearch {
      width: 100%;
      padding: 24px;
      margin-bottom: 32px;
      border-radius: 8px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -2px rgba(0, 0, 0, 0.1);

      .searchWrapper {
        display: flex;
        align-items: center;
        gap: 16px;

        .searchBar {
          flex-grow: 1;
          padding: 12px 24px;
          border: 1px solid rgb(209 213 219);
          border-radius: 12px;
          font-size: 1rem;
        }

        .searchBtn {
          flex-shrink: 0;
          padding: 12px 24px;
          background: linear-gradient(to right, #0096c7, #00b4d8);
          color: #fff;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.95rem;
          cursor: pointer;

          .mobileLabel {
            display: none;
          }
        }
      }
    }

    .complaintsList {
      width: 100%;
      padding: 24px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -2px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .complaintThumb {
        border-bottom: 1px solid rgb(209 213 219);
        &:not(:last-of-type) {
          margin-bottom: 24px;
        }

        &.show {
          .thumbHeader {
            .headerarrow {
              svg {
                transform: rotate(180deg);
              }
            }
          }
          .thumbMain {
            grid-template-rows: 1fr;

            .mainContainer {
              padding-bottom: 24px;
            }
          }
        }

        .thumbHeader {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 24px;
          cursor: pointer;

          .headerInfo {
            .headerTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 1.05rem;
              line-height: 1.75rem;
              margin-bottom: 6px;
              display: flex;
              align-items: center;
              gap: 12px;
              .headerStatusThumb {
                padding: 4px 12px;
                border-radius: 9999px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #166534;
                background: #bbf7d0;
                font-size: 0.75rem;
                font-family: "iranyekan", sans-serif;
                &.approved {
                  color: #166534;
                  background: #bbf7d0;
                }
                &.pending {
                  color: #92400e;
                  background: #fed7aa;
                }
              }
            }
            .headerDate {
              font-size: 0.95rem;
              color: #6b7280;
            }
          }
          .headerarrow {
            padding-left: 24px;
            opacity: 0.5;
            svg {
              width: 20px;
              height: 20px;
              transition: all 0.3s;
            }
          }
        }

        .thumbMain {
          display: grid;
          grid-template-rows: 0fr;
          width: 100%;
          transition: all 0.3s;
          overflow: hidden;

          .mainContainer {
            overflow: hidden;
            .mainRow {
              margin-bottom: 24px;
              &.gridRow {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 24px;
              }

              .rowColumn {
                .columnTitle {
                  font-size: 0.875rem;
                  line-height: 1.25rem;
                  margin-bottom: 4px;
                  color: #6b7280;
                }
                .columnValue {
                  font-size: 0.9rem;
                  line-height: 24px;
                  text-align: justify;
                }
              }
            }

            .responseThumb {
              position: relative;
              padding: 16px;
              background: #eff6ff;
              border-right: 4px solid #0096c7;
              border-top-left-radius: 8px;
              border-bottom-left-radius: 8px;

              .thumbHeader {
                font-size: 0.9rem;
                margin-bottom: 8px;
              }

              .thumbMain {
                font-size: 0.9rem;
                color: #1f2937;
                margin-bottom: 12px;
                line-height: 24px;
                text-align: justify;
              }

              .thumbFooter {
                font-size: 0.875rem;
                line-height: 1.25rem;
                color: #6b7280;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .dark {
    .tracking {
      .trackingContainer {
        .containerSearch {
          box-shadow: none !important;
        }
        .complaintsList {
          box-shadow: none !important;
        }
      }
    }
  }
  .tracking {
    padding-top: 0;
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .desktopTitleWrapper {
      display: none;
    }

    .trackingTitleWrapper {
      display: block;
    }

    .trackingContainer {
      width: 100%;
      padding-top: 16px;

      .containerSearch {
        padding: 0;
        box-shadow: none;

        .searchBtn {
          padding: 0 !important;
          height: 40px;
          aspect-ratio: 1;

          .desktopLabel {
            display: none;
          }

          .mobileLabel {
            display: block !important;

            svg {
              width: 18px;
              height: 18px;
            }
          }
        }
      }

      .complaintsList {
        padding: 0;
        box-shadow: none;
      }
    }
  }
}

.dark {
  .tracking {
    color: #fff;
    .desktopTitleWrapper {
      .desktopTitle {
        &::after {
          background: #fff;
        }
        &::before {
          background: #ccc;
        }
      }
    }

    .trackingContainer {
      .containerSearch {
        box-shadow: 0 4px 6px -1px rgba(255, 255, 255, 0.1),
          0 2px 4px -2px rgba(255, 255, 255, 0.1);
        .searchWrapper {
          .searchBar {
            background: #101a23;
            color: #fff;
            border-color: #9197a1;
          }
        }
      }

      .complaintsList {
        box-shadow: 0 4px 6px -1px rgba(255, 255, 255, 0.1),
          0 2px 4px -2px rgba(255, 255, 255, 0.1);

        .complaintThumb {
          border-color: #9197a1;

          .thumbHeader {
            .headerInfo {
              .headerTitle {
                .headerStatusThumb {
                  &.approved {
                    background: #0a1e13;
                    color: #26ab59;
                  }
                  &.pending {
                    color: #ff7723;
                    background: #27221b;
                  }
                }
              }
            }
          }

          .thumbMain {
            .mainContainer {
              .responseThumb {
                background: #1a2738 !important;
                .thumbMain {
                  color: #d9dce5;
                }
              }
            }
          }
        }
      }
    }
  }
}

.noResult {
  text-align: center;
  padding: 54px 0;
  font-size: 1.15rem;
}

.loadeMoreWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadMore {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #0096c7;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-top: 24px;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
